export default {
  knowledgeBase: 'AI Knowledge Base',
  knowledgeCorpus: 'Corpus',
  agentEvaluation: 'Agent Evaluation',
  addAgentEvaluationData: 'Add Agent Evaluation Data',
  agentEvaluationModalDesc:
    'Add selected feedback items into an existing dataset, or create a new evaluation dataset.',
  agentEvaluationAddExisting: 'Add to Existing Dataset',
  agentEvaluationCreateDataset: 'Create New Dataset',
  agentEvaluationConfirmAdd: 'Confirm Add',
  agentEvaluationSelectDataset: 'Please select a target dataset',
  agentEvaluationDatasetName: 'Dataset Name',
  agentEvaluationDatasetNamePlaceholder: 'Please enter the dataset name',
  agentEvaluationSelectedCount: '{val1} feedback items selected',
  agentEvaluationSampleCount: 'Samples: {val1}',
  agentEvaluationNoDataset:
    'No dataset is available yet. Please switch to "Create New Dataset".',
  agentEvaluationAddSuccess:
    '{val1} feedback items added, {val2} duplicate items skipped',
  agentEvaluationAddFailed: 'Failed to add agent evaluation data',
  agentEvaluationLoadFailed: 'Failed to load agent evaluation datasets',
  agentEvaluationPleaseSelectFeedback: 'Please select at least one feedback item',
  agentEvaluationEntryDesc:
    'Collect feedback samples here for future agent evaluation runs.',
  agentEvaluationGoFeedback: 'Go to Feedback Query',
  agentEvaluationViewDetail: 'View Dataset',
  agentEvaluationDeleteDatasetConfirm:
    'Are you sure you want to delete dataset "{val1}"?',
  agentEvaluationDeleteSampleConfirm:
    'Are you sure you want to delete feedback "{val1}"?',
  agentEvaluationDeleteDatasetSuccess: 'Dataset deleted successfully',
  agentEvaluationDeleteSampleSuccess: 'Sample deleted successfully',
  agentEvaluationDeleteFailed: 'Delete failed',
  agentEvaluationNoData: 'No agent evaluation data yet',
  agentEvaluationBackList: 'Back to Dataset List',
  agentEvaluationPageTitle: 'Agent Evaluation',
  agentEvaluationSelectDatasetEmpty:
    'No dataset is selected yet. Click "Select Dataset" to load evaluation samples.',
  agentEvaluationSelectDatasetDesc:
    'Please select a dataset before evaluation. Datasets should be created in Feedback Query first.',
  agentEvaluationCurrentDatasetUnavailable: 'The most recently used dataset is unavailable',
  agentEvaluationChooseDataset: 'Select Dataset',
  agentEvaluationSampleTitle: 'Evaluation Samples',
  agentEvaluationCriteriaTitle: 'Criteria and Weights',
  agentEvaluationResultTitle: 'Evaluation Result',
  agentEvaluationCriteriaGenerate: 'Generate Criteria and Weights',
  agentEvaluationCriteriaSave: 'Save',
  agentEvaluationStart: 'Start Evaluation',
  agentEvaluationBackEdit: 'Back to Edit',
  agentEvaluationSharedMode: 'Shared Criteria',
  agentEvaluationSharedModeDesc: 'All samples in this run share the same criteria and weights',
  agentEvaluationPerSampleMode: 'Per-Sample Criteria',
  agentEvaluationPerSampleModeDesc:
    'Generate and maintain a dedicated set of criteria for each feedback sample',
  agentEvaluationSelectModeFirst: 'Please select a criteria mode first',
  agentEvaluationGenerateEmpty: 'No criteria yet. Generate or add criteria manually.',
  agentEvaluationModeEmpty: 'Please select a criteria mode before generating criteria.',
  agentEvaluationCriteriaSaved: 'Criteria and weights saved',
  agentEvaluationCriteriaGenerated: 'Criteria and weights generated',
  agentEvaluationCriteriaGenerateFailed: 'Failed to generate criteria and weights',
  agentEvaluationCriteriaGenerateTimeout: 'Criteria generation timed out, please try again later',
  agentEvaluationCriteriaSaveFailed: 'Failed to save criteria and weights',
  agentEvaluationCriteriaResetOnModeChange:
    'No dataset selected, the criteria being edited has been cleared',
  agentEvaluationNeedDataset: 'Please select an evaluation dataset first',
  agentEvaluationNeedCriteria: 'Please generate or complete the evaluation criteria first',
  agentEvaluationResultWaiting:
    'After selecting a dataset and starting evaluation, the overall result and per-sample details will be shown here.',
  agentEvaluationResultPending: 'Waiting to start evaluation',
  agentEvaluationResultEvaluating: 'Evaluating...',
  agentEvaluationAverageScore: 'Average Score',
  agentEvaluationRunSuccess: 'Evaluation completed',
  agentEvaluationRunFailed: 'Evaluation failed',
  agentEvaluationRunTimeout:
    'Evaluation timed out, please check the evaluation history later',
  agentEvaluationCriteriaColumn: 'Criteria',
  agentEvaluationWeightColumn: 'Weight',
  agentEvaluationCriteriaColumnTooltip:
    'A rule description that should be satisfied, for example: the answer contains json',
  agentEvaluationWeightColumnTooltip: 'Only numbers between 0 and 2 are allowed',
  agentEvaluationSampleTabPrefix: 'Sample',
  agentEvaluationNoDatasetInModal:
    'There is no evaluation dataset yet. Please create one in Feedback Query first.',
  agentEvaluationManageDataset: 'Manage Datasets',
  agentEvaluationGoCreateDataset: 'Create Dataset in Feedback Query',
  agentEvaluationCreateDatasetGuide:
    'How to create a dataset: Feedback Query -> select feedback -> More Actions -> Add Agent Evaluation Data',
  agentEvaluationUseDataset: 'Use Dataset',
  agentEvaluationDatasetLoaded: 'Dataset loaded: {val1}',
  agentEvaluationSummaryTotal: 'Total {val1} samples',
  agentEvaluationSummarySuccess: 'Succeeded {val1}',
  agentEvaluationSummaryFailed: 'Failed {val1}',
  agentEvaluationAddCriteria: 'Add Criteria',
  agentEvaluationDeleteCriteria: 'Delete Criteria',
  agentEvaluationExpandResult: 'Expand Result',
  agentEvaluationCollapseResult: 'Collapse Result',
  agentEvaluationExpandFailedReason: 'Show Failure Reason',
  agentEvaluationCollapseFailedReason: 'Hide Failure Reason',
  agentEvaluationHistoryButton: 'Evaluation History',
  agentEvaluationHistoryEmpty: 'No evaluation history yet',
  agentEvaluationHistoryLoadFailed: 'Failed to load evaluation history',
  agentEvaluationHistoryDetailFailed: 'Failed to load historical evaluation result',
  agentEvaluationHistorySequence: 'Run #{val1}',
  agentEvaluationHistoryDatasetLabel: 'Dataset: {val1}',
  knowledgeCorpusDesc: 'Knowledge base content will be used as background knowledge to optimize the reply quality of intelligent customer service and the recommendation effect of intelligent replies.',
  addKnowledgeBase: 'Add Knowledge Base',
  document: 'Doc',
  table: 'Table',
  lastModifiedTime: 'Last Modified Time',
  lastUpdateTime: 'Latest Release',
  lastPublishTime: 'Latest Publish Time',
  referenceCount: 'Reference Count',
  referenceCountTips:
    "The number of times the corpus in the knowledge base matches the user's question.",
  resolutionRateTips:
    "The number of times the corpus in the knowledge base solves the user's problem / the number of times the corpus in the knowledge base is used.",
  knowledgeBaseName: 'Knowledge Base Name',
  pleaseEnterTheName: 'Please enter the knowledge base name',
  description: 'Knowledge Base Description',
  pleaseEnterTheDescription: 'Please enter the knowledge base description',
  noDescription: 'No description',
  importFormatTips: 'Currently only supports importing local files in xlsx format; document, iwiki and other import methods will be supported later.',
  determine: 'Create and Import',
  cancel: 'Cancel',
  format: 'Knowledge Base Format',
  tableDescriptionTips: 'Suitable for structured question-and-answer data.',
  tableFormat: 'Table Format',
  firstImportType: 'First Import Type',
  supportXlsxLocalFile: 'Supports xlsx format local file',
  importTable: 'Import Table',
  upload: 'Upload',
  preview: 'Preview',
  nextStep: 'Next Step',
  previousStep: 'Previous Step',
  import: 'Import',
  clickToUpload: 'Click or drag to upload table file (.xlsx)',
  uploadFailed: 'Upload failed!',
  parseFailed:
    'Failed to parse the table. Please check that the format and content are correct.',
  question: 'Question',
  answer: 'Answer',
  datasourceTips: 'Total {val1} data',
  documentParsingRecord: 'Document Parsing Record',
  total: 'Total {val1}',
  hitCount: 'Recent 7-day References',
  likeCount: 'Recent 7-day Votes',
  enabled: 'Enabled',
  createTime: 'Create Time',
  creator: 'Creator',
  created: 'Created',
  operation: 'Operation',
  edit: 'Edit',
  delete: 'Delete',
  questionName: 'Question Name',
  pleaseEnterFi: 'Please enter the {val1}',
  status: 'Status',
  disabled: 'Disabled',
  allStatuses: 'All Statuses',
  count: 'times',
  resolutionRate: 'Resolution Rate',
  confirmDeletion: 'Confirm Deletion',
  confirmDeletion2: 'Are you sure you want to delete the knowledge base "{val1}"?',
  deleteSuccess: 'Delete success',
  deleteFailed: 'Delete failed',
  createFailed: 'Create failed',
  createKBSuccess: 'Knowledge base created successfully',
  createKBFailed: 'Failed to create knowledge base',
  editCorpus: 'Edit Corpus',
  createCorpus: 'Create Corpus',
  search: 'Search',
  neverExpire: 'Never Expire',
  whenSelectingFailure: 'Select Expiration Date',
  expireType: 'Expiration Date',
  pleaseSelectExpireDate: 'Please Select Expiration Date',
  selectDate: 'Select Date',
  atMost: 'At most {val1} characters',
  editFailed: 'Edit failed',
  editSuccess: 'Edit success',
  titleCannotBeEmpty: 'Title cannot be empty',
  createSuccess: 'Create success',
  repeatedContent: 'Repeated Corpus',
  setFaqStatusSuccess: 'Operation successful',
  confirmDeleteCorpus: 'After deletion, it cannot be recovered, please be cautious. ',
  aiCorpusRecommend: 'AI Corpus Recommendation',
  aiCorpusRecommendInfo: 'AI customer service response recommendations, generated based on recent conversations.',
  aiCorpusRecommendDesc: 'Recommendations from conversation data; adding updates AI customer service\'s default knowledge base.',
  selectAll: 'Select all',
  batchIgnore: 'Batch ignore',
  batchAdd: 'Batch add',
  ignore: 'Ignore',
  add: 'Add',
  noRecommendCorpus: 'Recommendations are generated regularly from conversation data, currently no recommended corpus.',
  loading: 'Loading...',
  recommendTime: 'Recommend Time',
  similarConversation: 'Similar Conversation',
  similarConversationCount: '{val1} similar conversations',
  viewAllInFeedbackSearch: 'View all {val1} in feedback search',
  index: 'Index',
  addSuccess: 'The corpus has been successfully added to the default knowledge base.',
  addFailed: 'Add failed',
  ignoreSuccess: 'Ignore success',
  ignoreFailed: 'Ignore failed',
  clearFilters: 'Clear filters',
  importSuccessful: 'Import completed, {val1} new data added',
  ignoreMessage: ', skipped {val1} data',
  resultModalTitle: 'Import Result',
  resultModalDuplicateTip: 'The following data duplicates existing knowledge base data and cannot be imported',
  gotIt: 'Got it',
  referencedKB: 'Referenced Knowledge Base',
  notice: 'Notice',
  publishCorpus: 'Publish Corpus To Customer Service',
  unsyncedChangesCount: 'changes unpublished',
  publishCorpusConfirm: 'This update contains {val1} corpus. Are you sure you want to publish this update to the customer service?',
  unpublishedLeaveTip: 'There are unpublished changes to the customer service. Are you sure you want to leave?',
  publishSuccessful: 'Publish successful! {val1} corpus published',
  syncToFaq: 'Sync to FAQ Management',
  syncToFaqDesc: 'New questions will be placed in a default group and hidden from users; existing questions will only have their content updated',
  goToSmartCustomer: 'Go to Smart Customer Service',
  batchFillTip: 'Want to fill the same answer for the selected {val1} questions?',
  expand: 'Expand',
  collapse: 'Collapse',
  batchFillPlaceholder: 'Enter answer content, will fill all selected items',
  batchFillButton: 'Fill All ({val1} selected)',
  emptyAnswerConfirm: '{val1} of the selected items have empty answers. Are you sure to add?',
  confirmAdd: 'Confirm',
  cancelText: 'Cancel',
  smartClassification: 'Smart Classification',
  modelListTab: 'Model List',
  operationRecordTab: 'Operation History',
  confirmEnableTitle: 'Confirm',
  confirmEnableContent: 'Confirm enable {val1}',
  confirmEnableDetail:
    'Only applies to newly collected feedback; historical classifications are unchanged.',
  v2MigrationTip:
    'This project has switched to Smart Classification 2.0. Please edit via Knowledge Base > Smart Classification.',
  goToSmartClassification: 'Go to Smart Classification',
  operationMatter: 'Action',
  operationFields: 'Changed Fields',
  modelID: 'Model ID',
  operator: 'Operator',
  operateTime: 'Time',
  modelDescriptionEmpty: 'No model description yet. Click to add one',
  modelInfoNotFound: 'Model basic information was not found.',
  modelNameRequired: 'Model name cannot be empty',
  editModelName: 'Edit model name',
  editModelDescription: 'Edit model description',
  saveWithEnter: 'Save (Enter)',
  cancelWithEsc: 'Cancel (Esc)',
  publishModel: 'Publish Model',
  confirmPublish: 'Confirm Publish',
  publishingModel: 'Publishing...',
  publishingTooltip: 'Publishing. Please wait...',
  publishDraftTooltip: 'Publish the current draft configuration online',
  modelPublishSuccess: 'Model published successfully',
  modelPublishFailed: 'Failed to publish model. Please try again later',
  publishingModelTitle: 'Publishing model. Please wait...',
  publishingModelHint:
    'Publishing syncs draft configuration to the online version and may take several minutes.',
  elapsedTime: 'Elapsed {val1}',
  publishingDoNotClose:
    'Do not close this page or refresh the browser, or the publish status may become inconsistent.',
  publishModelConfirmPrefix: 'You are about to publish model',
  currentModel: 'Current model',
  publishModelConfirmSuffix:
    ', which will overwrite the online version with these draft items:',
  publishImpactTree: 'All nodes in the current classification tree',
  publishImpactRules: 'All enabled classification rules',
  publishImpactModelConfig: 'Basic model configuration (name, description, etc.)',
  publishModelWarning:
    'Publishing may take several minutes and cannot be interrupted. Please make sure all changes have been reviewed before continuing.',
};
